import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import { NavLink } from "react-router-dom";
import CheckAccess from "components/checkAccess/CheckAccess";
// Components
import { FormattedMessage } from "react-intl";
import AuthRender from "../../containers/AuthRender";
const mapStateToProps = (state, ownProps) => {
  return {
    activeClass: state.app.menuLeftIndex === ownProps.menuData.id ? "active" : ""
  };
};

class MenuLeftItem extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  renderNavLink() {
    const { menuData } = this.props;
    const menuLeftAccessId = {
      visits: 11,
      phototheque: 10,
      planning: 7,
      questionnaire: 8
    };

    const displayNavLinkLeft = <NavLink to={`${menuData.path}`}>{this.renderContent()}</NavLink>;

    return <Fragment>{menuLeftAccessId[menuData.id] ? displayNavLinkLeft : displayNavLinkLeft}</Fragment>;
  }

  renderBlock() {
    return <div>{this.renderContent()}</div>;
  }

  renderContent() {
    const { menuData, activeClass } = this.props;

    return (
      <div
        className={`p-menu-second-sub-item ${activeClass}`}
        onClick={() => {
          if (menuData.onClick) {
            menuData.onClick();
          }
        }}
      >
        <FormattedMessage id={menuData.label} defaultMessage={menuData.label}>
          {txt => <React.Fragment>{txt}</React.Fragment>}
        </FormattedMessage>
      </div>
    );
  }

  render() {
    const { menuData } = this.props;
    return menuData.path ? this.renderNavLink() : this.renderBlock();
  }
}

export default connect(
  mapStateToProps,
  null
)(MenuLeftItem);



// WEBPACK FOOTER //
// src/components/menu/MenuLeftItem.js